import React, { useState, useEffect } from 'react';
import Headline from 'headline';
import Button from 'button';
import Img from 'components/shared/img';
import Smoke from 'components/shared/smoke-canvas';
import { debouncedNavigation } from '../../../utility';
import s from './hero.module.scss';
import ismobile from './ismobile';

export default function Hero({ setModalOn, browser: isSafari }) {
  const [showVideo, setShowVideo] = useState(false);

  const heroWheeling = event => {
    const direction = event.deltaY < 0 ? 'up' : 'down';
    if (direction === 'down') {
      debouncedNavigation('#exhibits');
      const videoPlayer = document.querySelector('video');
      videoPlayer && videoPlayer.pause();
    }
  };

  const [touchStart, setTouchStart] = useState(0);

  const handleTouchUp = event => {
    const position = event.changedTouches[0].clientY;
    if (position < touchStart) {
      debouncedNavigation('#exhibits');
      const videoPlayer = document.querySelector('video');
      videoPlayer && videoPlayer.pause();
    }
  };

  const handleTouchStart = event => {
    setTouchStart(event.changedTouches[0].clientY);
  };

  useEffect(() => {
    const connectionForVideo =
      !navigator.connection || navigator.connection.effectiveType === '4g';
    setShowVideo(connectionForVideo);
    if (connectionForVideo && !ismobile()) {
      const script = document.createElement('script');
      script.src =
        'https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=165b1a2c09fc220d867222448d51cf89';
      document.head.appendChild(script);
    }
  }, []);

  return (
    <div
      onWheel={heroWheeling}
      className={s.hero}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchUp}
    >
      <div id="video-wrapper" className={s.videoContainer}>
        {showVideo && !ismobile() ? (
          <div
            dangerouslySetInnerHTML={{
              __html:
                '<stream style="height: 100vh" src="165b1a2c09fc220d867222448d51cf89" autoplay loop mute />'
            }}
          />
        ) : (
          <Img src="poster" jpg />
        )}
      </div>
      <div className={s.content} data-tilt>
        <Headline h1 className={s.headline}>
          <span className={s.one}>THE WORLD'S ONLY</span>
          <span className={s.two}>IMMERSIVE</span>
          <span className={s.three}>CANNABIS</span>
          <span className={s.four}>MUSEUM</span>
        </Headline>
      </div>
      <div className={`${s.buttons} ${isSafari ? s.safari : ''}`}>
        <Button
          invert
          bold
          className={s.btn1}
          onClick={() => {
            debouncedNavigation('#exhibits');
            const videoPlayer = document.querySelector('video');
            videoPlayer && videoPlayer.pause();
          }}
        >
          EXPLORE
        </Button>
        {/* <Button bold className={s.btn2} onClick={setModalOn}>
          BUY TICKETS
        </Button> */}
      </div>
      <Smoke />
    </div>
  );
}
